import classNames from "classnames";
import { FC } from "react";
import { Controller } from "react-hook-form";

export const RsvpFormWillAttend: FC = () => {
  return (
    <Controller
      name="willAttend"
      rules={{ required: true }}
      render={({
        field: { onChange, onBlur },
        fieldState: { invalid },
        formState: { isSubmitting },
      }) => {
        return (
          <div className="form-check-wrapper">
            <div className="form-check form-check-inline">
              <input
                disabled={isSubmitting}
                onChange={onChange}
                onBlur={onBlur}
                type="radio"
                id="attend_wedding_yes"
                value="true"
                className={classNames("form-check-input required", {
                  "is-invalid": invalid,
                })}
              />
              <label htmlFor="attend_wedding_yes">Yes, will attend.</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                onChange={onChange}
                onBlur={onBlur}
                className={classNames("form-check-input required", {
                  "is-invalid": invalid,
                })}
                type="radio"
                id="attend_wedding_no"
                value="false"
              />
              <label htmlFor="attend_wedding_no">Sorry, I can't come.</label>
            </div>
          </div>
        );
      }}
    />
  );
};
